// Global introduction of vant ui components
import {
  showToast,
  showDialog,
  showNotify,
  showImagePreview,
  Lazyload,
  Swipe,
  SwipeItem,
  ActionSheet,
  TextEllipsis,
  Button,
  BackTop,
  Tab,
  Tabs,
  Popup,
  Toast,
  SwipeCell,
  IndexBar,
  CountDown,
  Loading
} from 'vant';
import 'vant/es/toast/style';
import 'vant/es/dialog/style';
import 'vant/es/notify/style';
import 'vant/es/image-preview/style';
export default function (app) {
  const componentList = [
    showToast,
    showDialog,
    showNotify,
    showImagePreview,
    Swipe,
    SwipeItem,
    ActionSheet,
    TextEllipsis,
    Button,
    BackTop,
    Tab,
    Tabs,
    Popup,
    Toast,
    SwipeCell,
    IndexBar,
    CountDown,
    Loading
  ];
  componentList.forEach(
    component => (app.config.globalProperties[`$${component.name}`] = component)
  );
  const listUse = [Lazyload];
  listUse.forEach(component => app.use(component));
}
